// Importer nødvendige biblioteker
import io from 'socket.io-client';
import * as mediasoupClient from 'mediasoup-client';

// DOM-elementer
const localVideo = document.getElementById('localVideo');
const loginModal = document.getElementById('loginModal');
const loginButton = document.getElementById('loginButton');
const nameInput = document.getElementById('nameInput');
const passwordInput = document.getElementById('passwordInput');
const chatInput = document.getElementById('chatInput');
const messagesDiv = document.getElementById('messages');

// Socket.io klient
const hostname = "localhost"; // Skift til din serveradresse om nødvendigt
const port = '3000'; // Node.js server port
const nodeServerAddress = `http://${hostname}:${port}`;
const socket = io(nodeServerAddress); // Forbind til din Node.js server

// Brugervariabler
let name;
let device;
let producer;
let sendTransport;

// Kontroller DOM-elementer
if (!localVideo || !loginModal || !loginButton || !nameInput || !passwordInput) {
  console.error('Et eller flere DOM-elementer mangler. Kontrollér HTML-strukturen.');
}

// Login-handling
loginButton.addEventListener('click', () => {
  name = nameInput.value.trim();
  const password = passwordInput.value.trim();
  if (name && password) {
    socket.emit('joinLobby', { name, password });
  } else {
    alert('Indtast venligst dit navn og adgangskode');
  }
});

// Håndterer vellykket login
socket.on('joinedLobby', () => {
  loginModal.style.display = 'none';
  startMedia();
  console.log("Joined lobby");
});

// Håndterer fejlmeddelelser
socket.on('errorMessage', (message) => {
  alert(message);
});

// Start media og WebRTC-forbindelse
async function startMedia() {
  try {
    console.log('Anmoder om adgang til kamera og mikrofon...');
    
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    if (!stream) throw new Error('Kunne ikke få adgang til kamera/mikrofon.');

    console.log('Media stream oprettet:', stream);
    localVideo.srcObject = stream;

    // Debug hver gang `getUserMedia` køres
    console.log('Stream tracks:', stream.getTracks());

    stream.getVideoTracks().forEach((track) => {
      console.log(`Video track state: ${track.readyState}`);
      console.log(`Video track muted: ${track.muted}`);
    });

    // Hent RTP kapabiliteter fra serveren
    const routerRtpCapabilities = await sendRequest('getRouterRtpCapabilities');
    console.log('Router RTP Capabilities:', routerRtpCapabilities);

    // Initialiser mediasoup-client Device
    device = new mediasoupClient.Device();
    await device.load({ routerRtpCapabilities });
    console.log('Device initialiseret:', device);

    // Opret send transport
    const sendTransportParams = await sendRequest('createWebRtcTransport', { producing: true, consuming: false });
    console.log('SendTransport parametre:', sendTransportParams);

    sendTransport = device.createSendTransport(sendTransportParams);

    // Debug transport events
    sendTransport.on('connectionstatechange', (state) => {
      console.log(`Send transport state: ${state}`);
      if (state === 'failed') alert('Transportforbindelse fejlede.');
    });

    sendTransport.on('connect', ({ dtlsParameters }, callback, errback) => {
      console.log('Forbinder send transport med DTLS parametre:', dtlsParameters);
      sendRequest('connectTransport', { transportId: sendTransport.id, dtlsParameters })
        .then(() => {
          console.log('Transport forbundet succesfuldt (Client)');
          callback();
        })
        .catch((error) => {
          console.error('Fejl ved forbindelsen (Client):', error);
          errback(error);
        });
    });

    sendTransport.on('icestatechange', (state) => {
      console.log(`ICE state changed: ${state}`);
    });
    
    sendTransport.getStats().then((stats) => {
      stats.forEach((report) => {
        if (report.type === 'local-candidate' || report.type === 'remote-candidate') {
          console.log(`ICE Candidate: ${report.type}`, report);
        }
      });
    });    

    sendTransport.getStats().then((stats) => {
      stats.forEach((report) => {
        if (report.type === "candidate-pair" && report.state === "succeeded") {
          console.log('Successful ICE candidate pair:', report);
        }
      });
    });    

    sendTransport.on('connectionstatechange', (state) => {
      console.log(`Send transport connection state: ${state}`);
    });

    sendTransport.on('produce', ({ kind, rtpParameters }, callback, errback) => {
      console.log('Producer anmodning modtaget:', kind);
      sendRequest('produce', {
        transportId: sendTransport.id,
        kind,
        rtpParameters,
      }).then(({ id }) => {
        console.log('Producer oprettet med ID:', id);
        callback({ id });
      }).catch((error) => {
        console.error('Fejl ved oprettelse af producer:', error);
        errback(error);
      });
    });



    // Producer video
    const videoTrack = stream.getVideoTracks()[0];
    console.log('Video track:', videoTrack);

    producer = await sendTransport.produce({ track: videoTrack });
    console.log('Producer oprettet:', producer);

    // Debug producer stats
    producer.getStats().then((stats) => {
      stats.forEach((report) => {
        console.log(`Producer report type: ${report.type}`);
        console.log('Producer report details:', report);
      });
    });
    
    sendTransport.getStats().then((stats) => {
      stats.forEach((report) => {
        console.log(`Transport report type: ${report.type}`);
        console.log('Transport report details:', report);
      });
    });

  } catch (error) {
    console.error('Fejl ved start af medier:', error);
    alert('Kunne ikke starte medier: ' + error.message);
  }
}

// Hjælpefunktion til at sende anmodninger til serveren
function sendRequest(action, data = {}) {
  return new Promise((resolve, reject) => {
    socket.emit('webrtcRequest', { action, data }, (response) => {
      if (response.error) {
        console.error(`Fejl i handling: ${action}`, response.error);
        reject(new Error(response.error));
      } else {
        resolve(response);
      }
    });
  });
}

// Håndter chatbeskeder
chatInput.addEventListener('keypress', (e) => {
  if (e.key === 'Enter') {
    const message = chatInput.value.trim();
    if (!message) {
      alert('Besked kan ikke være tom!');
      return;
    }
    socket.emit('chatMessage', { message });
    chatInput.value = '';
  }
});

socket.on('chatMessage', ({ from, message }) => {
  const msg = document.createElement('p');
  msg.textContent = `${from}: ${message}`;
  messagesDiv.appendChild(msg);
});

// Håndterer afvisning
socket.on('rejected', () => {
  alert('Dit opkald er blevet afvist.');
  window.close();
});

// Håndterer tildeling til kanal
socket.on('assignedToChannel', ({ channelId }) => {
  console.log('Tildelt til kanal:', channelId);
});
